// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#careline-banner-component .ant-table .ant-table-tbody tr td {\n  vertical-align: middle;\n}\n#careline-banner-component-drawer\n  .photo-uploader\n  .ant-upload.ant-upload-select-picture-card {\n  width: 100%;\n  /* height: 200px; */\n}\n", ""]);
// Exports
module.exports = exports;
